import { Column } from 'react-table'
import { formatDateTime } from '@/lib/helpers'

import { DataTable } from '@/components/DataDisplay/Table/DataTable'

type Row = {
  company_name: string
  email: string
  phone_number: string
  package_name: string
  start_date: string
  expiry: string
  user_type: string
  cancel_reason: string
}

type Props = {
  rows: Row[]
  isLoading: boolean
}

function StatsTable({ rows, isLoading }: Props) {
  const columns: Column<Row>[] = [
    {
      Header: 'Company',
      accessor: 'company_name',
      sortKey: 'company_name',
      width: '13%',
    },
    {
      Header: 'Email',
      accessor: 'email',
      sortKey: 'email',
      width: '15%',
    },
    {
      Header: 'Phone No.',
      disableSortBy: true,
      accessor: 'phone_number',
      width: '12%',
    },
    {
      Header: 'Package',
      accessor: 'package_name',
      disableSortBy: true,
      width: '10%',
      Cell: ({ value }) =>
        value
          .split('_')
          .map((w: string) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' '),
    },
    {
      Header: 'Start Package',
      accessor: 'start_date',
      disableSortBy: true,
      width: '12%',
      Cell: ({ value }) => formatDateTime(value, 'DD MMM YYYY HH:mm')
    },
    {
      Header: 'End Package',
      accessor: 'expiry',
      disableSortBy: true,
      width: '12%',
      Cell: ({ value }) => formatDateTime(value, 'DD MMM YYYY HH:mm')
    },
    {
      Header: 'User Type',
      accessor: 'user_type',
      disableSortBy: true,
      width: '10%',
    },
    {
      Header: 'Cancel Reason',
      accessor: 'cancel_reason',
      disableSortBy: true,
      width: '16%',
    },
  ]

  return (
    <DataTable<Row>
      columns={columns}
      data={rows || []}
      isLoading={isLoading}
      showPagination
      autoResetPage={false}
      tableSx={{ mb: 0 }}
      tableStyle={{ minH: 'auto' }}
    />
  )
}

export default StatsTable;
